import { h, Component } from 'preact';
import './index.less';
import { getAssetPath } from '../../lib/Utils';
import { qsTileDownloadClick, onCloseBannerClick } from '../../lib/Events';
import { createOrGetVisitor } from '../../lib/Visitor';
import { getShowcaseId, getShowcaseSlug } from '../../lib/Showcase';
import { getCompanyName, getCompanyId } from '../../lib/Company';
import { getDatabaseRef, setDatabaseRef } from '../../lib/Firebase';
import I18n from '../../lib/I18n';
import { showCreateFreeCatalogueBannerHighVisiblity as greenBanner } from '../../lib/Amalgam';
import { getCatalogueTheme, getCatalogueThemeId } from '../../lib/Theme';

class FreeCatalogueBanner extends Component {
  state = {};

  getUrl = () => {
    let url = 'https://quicksell.co/download?';
    url += `source=https://quicksell.co/s/${getShowcaseSlug()}`;
    const companyId = getCompanyId();
    if (companyId) {
      url += `&medium=${companyId}`;
    }
    const companyName = getCompanyName();
    if (companyName) {
      url += `&content=${companyName}`;
    }
    url += '&campaign=catalogue_header_banner_campaign';
    return url;
  };

  download = (event) => {
    event.stopPropagation();
    qsTileDownloadClick('banner_click');
    createOrGetVisitor().then((visitor) => {
      const ref = getDatabaseRef(`link-ref/${getShowcaseId()}/${visitor.id}`);
      setDatabaseRef(ref, 'home').catch(() => {});
    });
  };

  closeBanner = (e) => {
    e.stopPropagation();
    onCloseBannerClick();
    this.props.onClose();
  };

  render () {
    const bannerTheme = getCatalogueTheme().banner || {};
    let rocketIconPath = `rocket-${getCatalogueThemeId()}.svg`;
    if (greenBanner()) {
      rocketIconPath = 'rocket-dark.svg';
    }

    let closeIconPath = 'icon-close-green.svg';
    if (!greenBanner()) {
      closeIconPath = `icon-close-${getCatalogueThemeId()}.svg`;
    }

    return (
      <div
        className="free-catalogue-banner"
        style={{
          backgroundColor: greenBanner() ? '#148B65' : bannerTheme.backgroundColor
        }}
      >
        <a className="left-container" onClick={this.download} href={this.getUrl()} target="_blank" rel="noreferrer">
          <img src={getAssetPath(rocketIconPath)} width={20} height={20} />
          <p
            className="banner-text"
            style={{
              color: greenBanner() ? '#fff' : bannerTheme.textColor
            }}
          >
            {I18n.t(
              greenBanner() ? 'CREATE_CATALOGUE_HIGH_VISIBILITY' : 'CREATE_CATALOGUE_LOW_VISIBILITY'
            )}
          </p>
          {greenBanner() && (
            <img src={getAssetPath('arrow-long-right-white.svg')} width={20} height={20} />
          )}
        </a>
        <div className="right-container" onClick={this.closeBanner}>
          <img src={getAssetPath(closeIconPath)} width={20} height={20} />
        </div>
      </div>
    );
  }
}

export default FreeCatalogueBanner;
